import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    padding: '0 4px'
  },
  startDateRevenue: {
    marginTop: 8,
    width: '100%',
    height: 'auto',
    justifyContent: 'flex-start',
    padding: '8px 12px',
    '& .MuiSvgIcon-root': {
      marginRight: 10
    },
    '& .MuiChip-label': {
      paddingLeft: 0,
      fontSize: 13,
      fontWeight: 600,
      whiteSpace: 'normal'
    }
  },
  startDateWarning: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 6,
    marginTop: 6,
    '& .MuiSvgIcon-root': {
      width: 16,
      height: 16,
      flexShrink: 0,
      marginTop: 1
    }
  },
  termRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 16,
    marginTop: 16
  },
  trialRow: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-start',
    marginBottom: '8px'
  },
  trialNameField: {
    flex: 1
  },
  trialDaysField: {
    width: '120px'
  },
  section: {
    marginBottom: 20
  },
  sectionTitle: {
    marginBottom: 12
  },
  addControl: {
    marginBottom: 8
  },
  list: {
    maxHeight: 240,
    overflowY: 'auto'
  },
  listRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: 8,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    marginBottom: 8,
    '&:last-child': {
      marginBottom: 0
    }
  },
  listRowMain: {
    flex: 1,
    minWidth: 0,
    '& > *': {
      display: 'block'
    }
  },
  listRowRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0
  },
  scopeLabel: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: 8
  },
  checkboxLabel: {
    marginTop: 4
  },
  autocomplete: {
    width: '100%',
    '& .MuiFormControl-root .MuiInputBase-root': {
      paddingTop: '10px',
      paddingBottom: '9px'
    },
    '& .MuiFormLabel-root': {
      transform: 'translate(12px, 12px) scale(1)'
    }
  },
  addPricingHeaderItem: {
    opacity: 1,
    cursor: 'default',
    backgroundColor: '#E1E7EC',
    '&.Mui-focusVisible': {
      backgroundColor: '#E1E7EC'
    }
  },
  warningChip: {
    width: '100%',
    padding: '8px',
    marginBottom: 16,
    justifyContent: 'flex-start',
    '& .MuiSvgIcon-root': {
      marginRight: 4
    }
  },
  noActiveProperties: {
    '&.Mui-disabled': {
      display: 'block'
    }
  },
  defaultPriceSets: {
    display: 'flex',
    margin: '0 -4px',
    '& .MuiButton-root': {
      margin: '0 4px 8px 4px'
    }
  }
});
export default useStyles;